<template>
  <WidgetKpiCard
    :error="!!error"
    :loading="loading"
    :lastUpdate="lastUpdate"
    @click:refresh="refresh"
    @click:table="showTable"
  >
    <template #title>
      {{ $t("widgets.potential.title") }}
    </template>

    <template v-if="data" #main>
      <KpiMain :value="data.main.value" @click="onMainKpiClick"></KpiMain>
    </template>

    <template v-if="data" #subs>
      <KpiSub
        :title="dateNames.prevMonth"
        :format="deltaOnValue"
        :value="data.subs.previous_month.value"
      ></KpiSub>
      <KpiSub
        :title="$t('widgets.potential.typeCount')"
        :value="data.subs.pos_type_count.value"
      ></KpiSub>
    </template>
  </WidgetKpiCard>
</template>
<script>
import { inject, ref } from "vue-demi";

import { useWidgetApi } from "@/composables/api/widget";
import { useRouter } from "@/composables/router";
import { usePeriodNames } from "@/composables/date";

import WidgetKpiCard from "./WidgetKpiCard.vue";
import KpiSub from "./WidgetKpiCard/KpiSub.vue";
import KpiMain from "./WidgetKpiCard/KpiMain.vue";

export default {
  components: { WidgetKpiCard, KpiSub, KpiMain },

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const params = ref({
      domain: null
    });

    const { data, lastUpdate, loading, error, execute } = useWidgetApi(
      "/dashboard/potential",
      params
    );

    const router = useRouter();

    const showTable = () => {
      router.push({ name: "DashboardTable", query: { measure: "potential" } });
    };

    const showOnMap = inject("showOnMap");

    const onMainKpiClick = () => {
      showOnMap({
        measure: "potential"
      });
    };

    const dateNames = usePeriodNames();

    const deltaOnValue = v => {
      return (v >= 0 ? "+" : "") + Math.round(v) + "%";
    };

    return {
      data,
      error,
      loading,
      lastUpdate,
      dateNames,

      refresh: execute,
      showTable,
      onMainKpiClick,
      deltaOnValue
    };
  }
};
</script>
<style></style>
